module.exports = __webpack_public_path__ + "static/media/china-cover.b0705dc8.webp";